import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'yaziIsleri';

var evrakService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,

    evrakListele({dosyaDurumu, durum = 1, baslangic = 0, limit = 10000}) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[dosyaDurumu]': dosyaDurumu,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'evrakListele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    evrakAra({kayitKodu, dosyaDurumu, durum = 1, konu, islemTarihi, cariAdi, baslangic = 0, limit = 10000}) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[dosyaDurumu]': dosyaDurumu,
            'data[durum]': durum,
            'data[konu]': konu,
            'data[islemTarihi]': islemTarihi,
            'data[cariAdi]': cariAdi,
            'data[kayitKodu]': kayitKodu,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'evrakAra',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    evrakGuncelle({yaziIsleriID, dosyaDurumu, durum, konu, islemTarihi, cariID, belge}) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[yaziIsleriID]': yaziIsleriID,
            'data[dosyaDurumu]': dosyaDurumu,
            'data[durum]': durum,
            'data[konu]': konu,
            'data[islemTarihi]': islemTarihi,
            'data[cariID]': cariID != undefined ? cariID : '',
            'belge': belge,
            serviceName: moduleName,
            methodName: 'evrakGuncelle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    evrakDurumDegistir({yaziIsleriID, durum}) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[yaziIsleriID]': yaziIsleriID,
            'data[durum]': durum,
            serviceName: moduleName,
            methodName: 'evrakDurumDegistir',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    evrakDetay({yaziIsleriID}) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[yaziIsleriID]': yaziIsleriID,
            serviceName: moduleName,
            methodName: 'evrakDetay',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    evrakEkle({cariID, dosyaDurumu, konu, islemTarihi, belge, durum = 1}) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[cariID]': cariID,
            'data[dosyaDurumu]': dosyaDurumu,
            'data[konu]': konu,
            'data[islemTarihi]': islemTarihi,
            'data[durum]': durum,
            'belge': belge,
            serviceName: moduleName,
            methodName: 'evrakEkle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    sunucuDosyaList() {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            serviceName: 'dosya',
            methodName: 'listele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    evrakSunucudanDosyaYukle(yaziIsleriID, dosyaID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[yaziIsleriID]': yaziIsleriID,
            'dosyaID': dosyaID,
            serviceName: moduleName,
            methodName: 'evrakSunucudanDosyaYukle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};

export default evrakService;
